import { registerComponent, asyncRequest, loading } from "helpers";
import {
  CART_SECTIONS_TO_RENDER,
  getCartSectionNames,
  renderCartSections,
  updateCartCount,
} from "cart-refresh";

registerComponent(
  "product-form",
  class ProductForm extends HTMLElement {
    SECTIONS_TO_RENDER = CART_SECTIONS_TO_RENDER;

    constructor() {
      super();

      this.form = this.querySelector("form");
      this.addToCartButton = this.querySelector('button[type="submit"]');
      // this.form.addEventListener("submit", this.handleSubmit.bind(this));
      if (this.form) {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
      }
      this.addMyRegistryAutomark();
    }

    handleSubmit(event) {
      event.preventDefault();

      loading.add(this.addToCartButton);
      this.addToCart();
    }

    getSectionNames() {
      return getCartSectionNames();
    }

    getBody() {
      const formData = new FormData(this.form);
      let productId = formData.get("id");
      if( productId == null) {
        var parent = this.form.closest('.product-add-to-cart-wrap');
        
       var elem =  parent.querySelectorAll('[form="'+this.form.getAttribute('id')+'"]')[0];
        productId = elem.getAttribute('value');
     //   console.log(elem,parent,productId);
      }
      const propertiesRegex = /properties\[(.*?)\]/;
      const attributesRegex = /attributes\[(.*?)\]/;

      const body = {
        items: [
          {
            id: productId,
            quantity: formData.get("quantity"),
            properties: {},
          },
        ],
        sections: this.getSectionNames(),
        attributes: {},
      };

      // Add cart attributes or line item properties to body
      Array.from(formData).forEach(([name, value]) => {
        const propertiesMatch = propertiesRegex.exec(name);
        const attributesMatch = attributesRegex.exec(name);

        if (propertiesMatch && propertiesMatch.length > 1) {
          body.items[0].properties[propertiesMatch[1]] = value;
        }

        if (attributesMatch && attributesMatch.length > 1) {
          body.attributes[attributesMatch[1]] = value;
        }
      });

      return body;
    }

    async addToCart() {
      const body = this.getBody();
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      const response = await asyncRequest(
        `${WYATT.routes.cart_add_url}.js`,
        options
      );

      if (response) {
        this.handleSuccessfulAdd(response);
      }

      loading.remove(this.addToCartButton);
    }

    handleSuccessfulAdd(state) {
      const parsedState = JSON.parse(state);

      window.WYATT.shopify.cart = parsedState;
      updateCartCount(parsedState);
      renderCartSections(parsedState.sections);
      document.querySelector('[data-drawer-open="[data-mini-cart]"]').click();
    }

    addMyRegistryAutomark() {
      const params = new URLSearchParams(document.location.search);
      const mrRID = params.get("mrRID");
      const mrTID = params.get("mrTID");

      if (mrTID) {
        this.appendHiddenInput("properties[_MyRegistry_TID]", mrTID);
      }

      if (mrRID) {
        this.appendHiddenInput("properties[_MyRegistry_RID]", mrRID);
      }
    }

    appendHiddenInput(name, value) {
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = name;
      hiddenInput.value = value;
      this.form.appendChild(hiddenInput);
    }
  }
);
